import React, { Component } from 'react';
import Breadcrumb from 'molecules/Breadcrumb';
import { actualLoadingCreate, actualLoadingDelete, actualLoadingUpdate} from 'fixtures/permissions';
import { permissionCheck } from 'helpers/permissionCheckHelper';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { setLocalSettingsTableData } from 'Redux/actions/SettingsTableActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Footer, LevelRowContainer, PageWrapper } from './styles';
import { withRouter } from 'react-router';
import { withTheme } from 'styled-components';
import { getAllList, postNewData } from 'services/cmsService';
import { BARGE_LOADING, CHECKLIST } from 'fixtures/api';
import lo from 'lodash';
import { NewBargeLoading } from 'fixtures/TemplateData'
import Header from 'organisms/ActualLoadingForm/Header';
import FuelConsumption from 'organisms/ActualLoadingForm/FuelConsumption';
import DraftSurvey from 'organisms/ActualLoadingForm/DraftSurvey';
import CoalTemperature from 'organisms/ActualLoadingForm/CoalTemperature';
import BargeSurveyCondition from 'organisms/ActualLoadingForm/BargeSurveyCondition';
import Attachments from 'organisms/ActualLoadingForm/Attachments';
import BargePerformance from 'organisms/ActualLoadingForm/BargePerformance';
import ButtonReg from 'components/atoms/Buttons/Button';
import { v4 as uuidv4 } from 'uuid';

export class ActualLoadingForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      form: lo.cloneDeep(NewBargeLoading),
      allowCreate: false,
      allowDelete: false,
      allowUpdate: false,
      loadingId: null,
    }
  }

  componentDidMount() {
    this.props.toggleIsLoading(true)
    this.getLoadingId()
    this.fetchDetail()
    this.checkPermission()
    this.props.toggleIsLoading(false)
  }

  componentDidUpdate(prevProps) {
    const { userLogin } = this.props
    if (prevProps.userLogin !== userLogin) {
      this.checkPermission()
    }
  }

  getLoadingId() {
    const { match: { params }} = this.props
    if ( params && params.loadingId ) {
      this.setState({ loadingId: params.loadingId })
    }
  }

  fetchDetail = async () => {
    try {
    this.props.toggleIsLoading(true)
    const { match: { params }} = this.props
    if ( params && params.loadingId ) {
      const data = await getAllList(`${CHECKLIST}/${params.loadingId}?type=${BARGE_LOADING}`)
      this.setState({ form: { ...this.state.form, ...data }})
    }
    } catch (error) {
      console.error(error);
    } finally {
      this.props.toggleIsLoading(false)
    }
  }

  // method for checking access permission
  checkPermission() {
    const { userLogin } = this.props
    if (userLogin && userLogin.userDetail) {
      const { userDetail: { permissions } } = userLogin
      this.setState({
        allowCreate: permissionCheck(permissions, actualLoadingCreate),
        allowDelete: permissionCheck(permissions, actualLoadingDelete),
        allowUpdate: permissionCheck(permissions, actualLoadingUpdate),
      })
    }
  }

  onChange = (key, val) => {
    const form = lo.cloneDeep(this.state.form)
    form[key] = val
    if (key === 'tugName'){
      form['tugName'] = val.name || val
      if (val.requestId || val.recordId) {
        form['bargeName'] = val.barge
        form['bargeSize'] = val.bargeSize
        form['loadingRequestId'] = val.requestId
        form['loadingPlanId'] = val.loadingPlanId
        form['route'] = val.route
        form['loadType'] = val.shipmentType
        form['coalQuality'] = val.coalQuality
        form['noServicesTrip'] = val.tripID
      }
    }
    this.setState({ form })
  }

  onChangeForm = (form) => {
    this.setState({ form })
  }

  onCancel = () => {
    if (this.props.location.state && this.props.location.state.from) {
      this.props.history.push(this.props.location.state.from)
    } else {
      this.props.history.push('/dash/actual-loading')
    }
  }

  onSubmit = async () => {
    const { toggleIsLoading } = this.props
    try {
      toggleIsLoading(true)
      const form = lo.cloneDeep(this.state.form)
      const uploadAttachment = form.attachments.filter(d => !d.id)
      const attachments = uploadAttachment.map(d => ({...d, id: uuidv4()}))
      form['attachmentsBase64'] = attachments
      form['id'] = form.id || uuidv4()
      const res = await postNewData(`${CHECKLIST}?type=${BARGE_LOADING}`, lo.omit(form, ['notificationSentAt', 'status', 'noRefReport', 'attachments', 'updatedAt', 'updatedBy', 'finalizationId']))

      if (res.status < 400) {
        this.onCancel()
      } else {
        const message = res.message ? res.message : `Failed to ${this.state.loadingId ? 'edit':'submit'} actual loading`
        alert(message)
        throw res
      }
    } catch (error) {
      console.error(error);
    } finally {
      toggleIsLoading(false)
    }
  }

  render() {
    const { loadingId, form } = this.state
    const navList = [
      'Actual Loading',
      `${loadingId ? 'Edit' : 'Add'} Actual Loading`
    ]
    const { viewState: { isMobileView } } = this.props

    return (
      <PageWrapper isMobile={isMobileView}>
        <Breadcrumb navList={navList} />
        <Header form={form} onChange={this.onChange} onChangeForm={this.onChangeForm}/>
        <LevelRowContainer>
          <FuelConsumption form={form} onChange={this.onChange} />
          <DraftSurvey form={form} onChange={this.onChange} />
        </LevelRowContainer>
        <LevelRowContainer>
          <BargeSurveyCondition form={form} onChange={this.onChange} />
          <CoalTemperature form={form} onChange={this.onChange} />
        </LevelRowContainer>
        <Attachments form={form} onChange={this.onChange} onChangeForm={this.onChangeForm} />
        {loadingId && <BargePerformance />}
        <Footer>
          <ButtonReg
            transparent
            btnTxt={'Cancel'}
            onClick={() => this.onCancel()}
            width={'150px'}
            margin="0 10px 0 0"
          />
          <ButtonReg
            btnTxt={loadingId ? 'Edit' : 'Submit'}
            onClick={() => this.onSubmit()}
            width={'150px'}
          />
        </Footer>
      </PageWrapper>
    )
  }
}

const mapStateToProps = (state) => {

  return {
    userLogin: state.userLogin,
    viewState: state.viewState,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading,
      setLocalSettingsTableData,
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ActualLoadingForm)
  )
);
